<template>
    <div>
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <b> Print Receipt </b>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="receipt_data != null" id="wv_btn" class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Both" value="both" color="#0f2027"></v-radio>
                <v-radio label="Office Copy" value="office" color="#0f2027"></v-radio>
                <v-radio label="Student Copy" value="student" color="#0f2027"></v-radio>
            </v-radio-group>
            <!-- org_data==========={{org_basic_data}}
            receipt data=============={{ receipt_data }} -->
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-row v-if="receipt_data != null && radios != 'both'">
              <v-col cols="12" sm="6" md="6" class="m-0 p-0" v-if="radios == 'office'">
                  <v-card>
                      <v-simple-table dense class="elevation-1 table-container">
                          <template v-slot:default>
                              <thead>
                                  <tr>
                                      <td colspan="3" class="text-right">Office Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          <center>
                                              <b>Refunded Fees Receipt</b>
                                          </center>
                                      </td>
                                  </tr>
                                  <tr>
                                      <td v-if="org_basic_data.school_logo" class="logo">
                                          <center>
                                              <img :src="org_basic_data.school_logo" width="80%" alt="logo" />
                                          </center>
                                      </td>
                                      <td colspan="2">                                          
                                              <!-- <tr v-if="org_basic_data.trust_name">
                                                  <b>{{ org_basic_data.trust_name }}</b>
                                              </tr> -->
                                              <tr v-if="org_basic_data.school_name">
                                                  <b class="schl-name">{{ org_basic_data.school_name }} </b>
                                              </tr>
                                              <tr v-if="org_basic_data.address">
                                                  {{ org_basic_data.address }} 
                                              </tr>
                                              <tr v-if="org_basic_data.phone">
                                                 <b> Phone :</b> {{ org_basic_data.phone }}
                                              </tr>
                                              <tr v-if="org_basic_data.email">
                                                <b>  Email :</b> {{ org_basic_data.email }}
                                              </tr>
                                              <tr v-if="org_basic_data.website">
                                                <b>  Website : </b>{{ org_basic_data.website }}
                                              </tr>                                          
                                      </td>                                      
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr style="text-align: center;">                                      
                                      <td colspan="3">
                                         <b> Academic Year :</b> {{ receipt_data.academicyear }}
                                      </td>                                      
                                  </tr>
                                  <tr>
                                      <td colspan="1" class="text-left" style="width: 28%;"> 
                                         <b> Reg. No. :</b> {{ receipt_data.learner }}
                                      </td>
                                      <td style="width: 35%" colspan="1">                                          
                                      </td>
                                      <td colspan="1" class="text-left">
                                         <b> Receipt No. :</b> {{ receipt_data.receipt_no }}
                                      </td>
                                  </tr>
                                  <tr>
                                      <td colspan="1" class="text-left">
                                         <b> Standard :</b> {{ receipt_data.standard }}
                                      </td>
                                      <td colspan="1">
                                          
                                      </td>
                                      <td colspan="1" class="text-left">
                                         <b> Receipt Date :</b> {{ receipt_data.receipt_date }}
                                      </td>
                                  </tr>
                                  <tr style="height: 30px;">
                                      <td colspan="2"  class="text-center"><b>Fee Type</b></td>
                                      <td class="text-center"><b> Fee Amount (Rs.)</b></td>
                                  </tr>                            
                              
                                  <tr style="height: 30px;">
                                      <td colspan="2" class="text-center">
                                           {{ is_elective_refund ? 'Elective Fee' : 'Refunded amount' }}
                                      </td>
                                      <td class="text-center">{{ receipt_data.amount }}</td>
                                  </tr>
                              </tbody>                              
                              <tr>
                                  <td colspan="2" class="text-left">
                                      <b> Bank : </b>
                                      {{ receipt_data.bank }}
                                  </td>                                  
                                  <td colspan="1" class="text-left">
                                      <b> Remark : </b>
                                      {{ receipt_data.remark }}
                                  </td>
                              </tr>
                              <tr>
                                  <td colspan="2" class="text-left">
                                      <b> Payment Mode : </b>
                                      {{ receipt_data.paymentmode }}
                                  </td>
                                  <td colspan="1" class="text-left">
                                      <b> Transaction Id : </b>
                                      {{ receipt_data.trans_id }}
                                  </td>
                              </tr>                              
                              <tr>
                                  <td colspan="3" class="pl-0 text-left">
                                      <v-col cols="12" md="12" sm="12">
                                          <b>Date :</b> {{receipt_data.trans_date}}
                                      </v-col>
                                  </td>
                              </tr>
                          </template>
                      </v-simple-table>
                  </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="m-0 p-0" v-if="radios == 'student'">
                  <v-card>
                      <v-simple-table dense class="elevation-1 table-container">
                          <template v-slot:default>
                              <thead>
                                  <tr>
                                      <td colspan="3" class="text-right">Student Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          <center>
                                              <b>Refunded Fees Receipt</b>
                                          </center>
                                      </td>
                                  </tr>
                                  <tr>
                                      <td v-if="org_basic_data.school_logo" class="logo">
                                          <center>
                                              <img :src="org_basic_data.school_logo" width="80%" alt="logo" />
                                          </center>
                                      </td>
                                      <td colspan="2">                                          
                                              <!-- <tr v-if="org_basic_data.trust_name">
                                                  <b>{{ org_basic_data.trust_name }}</b>
                                              </tr> -->
                                              <tr v-if="org_basic_data.school_name">
                                                  <b class="schl-name">{{ org_basic_data.school_name }} </b>
                                              </tr>
                                              <tr v-if="org_basic_data.address">
                                                  {{ org_basic_data.address }} 
                                              </tr>
                                              <tr v-if="org_basic_data.phone">
                                                 <b> Phone :</b> {{ org_basic_data.phone }}
                                              </tr>
                                              <tr v-if="org_basic_data.email">
                                                <b>  Email :</b> {{ org_basic_data.email }}
                                              </tr>
                                              <tr v-if="org_basic_data.website">
                                                <b>  Website : </b>{{ org_basic_data.website }}
                                              </tr>                                          
                                      </td>                                      
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr style="text-align: center;">                                      
                                      <td colspan="3">
                                         <b> Academic Year :</b> {{ receipt_data.academicyear }}
                                      </td>                                      
                                  </tr>
                                  <tr>
                                      <td colspan="1" class="text-left" style="width: 28%;"> 
                                         <b> Reg. No. :</b> {{ receipt_data.learner }}
                                      </td>
                                      <td style="width: 35%" colspan="1">                                          
                                      </td>
                                      <td colspan="1" class="text-left">
                                         <b> Receipt No. :</b> {{ receipt_data.receipt_no }}
                                      </td>
                                  </tr>
                                  <tr>
                                      <td colspan="1" class="text-left">
                                         <b> Standard :</b> {{ receipt_data.standard }}
                                      </td>
                                      <td colspan="1">
                                          
                                      </td>
                                      <td colspan="1" class="text-left">
                                         <b> Receipt Date :</b> {{ receipt_data.receipt_date }}
                                      </td>
                                  </tr>
                                  <tr style="height: 30px;">
                                      <td colspan="2"  class="text-center"><b>Fee Type</b></td>
                                      <td class="text-center"><b> Fee Amount (Rs.)</b></td>
                                  </tr>                             
                              
                                  <tr style="height: 30px;">
                                      <td colspan="2" class="text-center">
                                          {{ is_elective_refund ? 'Elective Fee' : 'Refunded amount' }}
                                      </td>
                                      <td class="text-center">{{ receipt_data.amount }}</td>
                                  </tr>
                              </tbody>                              
                              <tr>
                                  <td colspan="2" class="text-left">
                                      <b> Bank : </b>
                                      {{ receipt_data.bank }}
                                  </td>                                  
                                  <td colspan="1" class="text-left">
                                      <b> Remark : </b>
                                      {{ receipt_data.remark }}
                                  </td>
                              </tr>
                              <tr>
                                  <td colspan="2" class="text-left">
                                      <b> Payment Mode : </b>
                                      {{ receipt_data.paymentmode }}
                                  </td>
                                  <td colspan="1" class="text-left">
                                      <b> Transaction Id : </b>
                                      {{ receipt_data.trans_id }}
                                  </td>
                              </tr>                              
                              <tr>
                                  <td colspan="3" class="pl-0 text-left">
                                      <v-col cols="12" md="12" sm="12">
                                          <b>Date :</b> {{receipt_data.trans_date}}
                                      </v-col>
                                  </td>
                              </tr>
                          </template>
                      </v-simple-table>
                  </v-card>
              </v-col>
          </v-row>
          <v-row v-if="receipt_data != null && radios == 'both'">
              <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                  <v-card>
                      <v-simple-table dense class="elevation-1 table-container">
                          <template v-slot:default>
                              <thead>
                                  <tr>
                                      <td colspan="3" class="text-right">Office Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          <center>
                                              <b>Refunded Fees Receipt</b>
                                          </center>
                                      </td>
                                  </tr>
                                  <tr>
                                      <td v-if="org_basic_data.school_logo" class="logo">
                                          <center>
                                              <img :src="org_basic_data.school_logo" width="80%" alt="logo" />
                                          </center>
                                      </td>
                                      <td colspan="2">                                          
                                              <!-- <tr v-if="org_basic_data.trust_name">
                                                  <b>{{ org_basic_data.trust_name }}</b>
                                              </tr> -->
                                              <tr v-if="org_basic_data.school_name">
                                                  <b class="schl-name">{{ org_basic_data.school_name }} </b>
                                              </tr>
                                              <tr v-if="org_basic_data.address">
                                                  {{ org_basic_data.address }} 
                                              </tr>
                                              <tr v-if="org_basic_data.phone">
                                                 <b> Phone :</b> {{ org_basic_data.phone }}
                                              </tr>
                                              <tr v-if="org_basic_data.email">
                                                <b>  Email :</b> {{ org_basic_data.email }}
                                              </tr>
                                              <tr v-if="org_basic_data.website">
                                                <b>  Website : </b>{{ org_basic_data.website }}
                                              </tr>                                          
                                      </td>                                      
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr style="text-align: center;">                                      
                                      <td colspan="3">
                                         <b> Academic Year :</b> {{ receipt_data.academicyear }}
                                      </td>                                      
                                  </tr>
                                  <tr>
                                      <td colspan="1" class="text-left" style="width: 28%;"> 
                                         <b> Reg. No. :</b> {{ receipt_data.learner }}
                                      </td>
                                      <td style="width: 35%" colspan="1">                                          
                                      </td>
                                      <td colspan="1" class="text-left">
                                         <b> Receipt No. :</b> {{ receipt_data.receipt_no }}
                                      </td>
                                  </tr>
                                  <tr>
                                      <td colspan="1" class="text-left">
                                         <b> Standard :</b> {{ receipt_data.standard }}
                                      </td>
                                      <td colspan="1">
                                          
                                      </td>
                                      <td colspan="1" class="text-left">
                                         <b> Receipt Date :</b> {{ receipt_data.receipt_date }}
                                      </td>
                                  </tr>
                                  <tr style="height: 30px;">
                                      <td colspan="2"  class="text-center"><b>Fee Type</b></td>
                                      <td class="text-center"><b> Fee Amount (Rs.)</b></td>
                                  </tr>                              
                              
                                  <tr style="height: 30px;">
                                      <td colspan="2" class="text-center">
                                          {{ is_elective_refund ? 'Elective Fee' : 'Refunded amount' }}
                                      </td>
                                      <td class="text-center">{{ receipt_data.amount }}</td>
                                  </tr>
                              </tbody>                              
                              <tr>
                                  <td colspan="2" class="text-left">
                                      <b> Bank : </b>
                                      {{ receipt_data.bank }}
                                  </td>                                  
                                  <td colspan="1" class="text-left">
                                      <b> Remark : </b>
                                      {{ receipt_data.remark }}
                                  </td>
                              </tr>
                              <tr>
                                  <td colspan="2" class="text-left">
                                      <b> Payment Mode : </b>
                                      {{ receipt_data.paymentmode }}
                                  </td>
                                  <td colspan="1" class="text-left">
                                      <b> Transaction Id : </b>
                                      {{ receipt_data.trans_id }}
                                  </td>
                              </tr>                              
                              <tr>
                                  <td colspan="3" class="pl-0 text-left">
                                      <v-col cols="12" md="12" sm="12">
                                          <b>Date :</b> {{receipt_data.trans_date}}
                                      </v-col>
                                  </td>
                              </tr>
                          </template>
                      </v-simple-table>
                  </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                  <v-card>
                      <v-simple-table dense class="elevation-1 table-container">
                          <template v-slot:default>
                              <thead>
                                  <tr>
                                      <td colspan="3" class="text-right">Student Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          <center>
                                              <b>Refunded Fees Receipt</b>
                                          </center>
                                      </td>
                                  </tr>
                                  <tr>
                                      <td v-if="org_basic_data.school_logo" class="logo">
                                          <center>
                                              <img :src="org_basic_data.school_logo" width="80%" alt="logo" />
                                          </center>
                                      </td>
                                      <td colspan="2">                                          
                                              <!-- <tr v-if="org_basic_data.trust_name">
                                                  <b>{{ org_basic_data.trust_name }}</b>
                                              </tr> -->
                                              <tr v-if="org_basic_data.school_name">
                                                  <b class="schl-name">{{ org_basic_data.school_name }} </b>
                                              </tr>
                                              <tr v-if="org_basic_data.address">
                                                  {{ org_basic_data.address }} 
                                              </tr>
                                              <tr v-if="org_basic_data.phone">
                                                 <b> Phone :</b> {{ org_basic_data.phone }}
                                              </tr>
                                              <tr v-if="org_basic_data.email">
                                                <b>  Email :</b> {{ org_basic_data.email }}
                                              </tr>
                                              <tr v-if="org_basic_data.website">
                                                <b>  Website : </b>{{ org_basic_data.website }}
                                              </tr>                                          
                                      </td>                                      
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr style="text-align: center;">                                      
                                      <td colspan="3">
                                         <b> Academic Year :</b> {{ receipt_data.academicyear }}
                                      </td>                                      
                                  </tr>
                                  <tr>
                                      <td colspan="1" class="text-left" style="width: 28%;"> 
                                         <b> Reg. No. :</b> {{ receipt_data.learner }}
                                      </td>
                                      <td style="width: 35%" colspan="1">                                          
                                      </td>
                                      <td colspan="1" class="text-left">
                                         <b> Receipt No. :</b> {{ receipt_data.receipt_no }}
                                      </td>
                                  </tr>
                                  <tr>
                                      <td colspan="1" class="text-left">
                                         <b> Standard :</b> {{ receipt_data.standard }}
                                      </td>
                                      <td colspan="1">
                                          
                                      </td>
                                      <td colspan="1" class="text-left">
                                         <b> Receipt Date :</b> {{ receipt_data.receipt_date }}
                                      </td>
                                  </tr>
                                  <tr style="height: 30px;">
                                      <td colspan="2"  class="text-center"><b>Fee Type</b></td>
                                      <td class="text-center"><b> Fee Amount (Rs.)</b></td>
                                  </tr>                              
                              
                                  <tr style="height: 30px;">
                                      <td colspan="2" class="text-center">
                                          {{ is_elective_refund ? 'Elective Fee' : 'Refunded amount' }}
                                      </td>
                                      <td class="text-center">{{ receipt_data.amount }}</td>
                                  </tr>
                              </tbody>                              
                              <tr>
                                  <td colspan="2" class="text-left">
                                      <b> Bank : </b>
                                      {{ receipt_data.bank }}
                                  </td>                                  
                                  <td colspan="1" class="text-left">
                                      <b> Remark : </b>
                                      {{ receipt_data.remark }}
                                  </td>
                              </tr>
                              <tr>
                                  <td colspan="2" class="text-left">
                                      <b> Payment Mode : </b>
                                      {{ receipt_data.paymentmode }}
                                  </td>
                                  <td colspan="1" class="text-left">
                                      <b> Transaction Id : </b>
                                      {{ receipt_data.trans_id }}
                                  </td>
                              </tr>                              
                              <tr>
                                  <td colspan="3" class="pl-0 text-left">
                                      <v-col cols="12" md="12" sm="12">
                                          <b>Date :</b> {{receipt_data.trans_date}}
                                      </v-col>
                                  </td>
                              </tr>
                          </template>
                      </v-simple-table>
                  </v-card>
              </v-col>
          </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                learner_receipt_data: null,
                radios: null,
                receipt_no: null,
                registration_no: null,
                ay: null,
                org_basic_data: [],
                is_elective_refund: false
            };
        },
        watch: {
          
          overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        created() {
            this.receipt_data = JSON.parse(this.$session.get("receipt_data"));
            this.org_basic_data = JSON.parse(this.$session.get("org_basic_data"));
            this.is_elective_refund = this.$session.get("is_elective_refund");
            alert(this.is_elective_refund)
        },
        mounted() {
            
        },
        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
        },
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        /* text-align: center; */
        font-size: 13px;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    tr {
        /* font-size: 0px; */
        /* white-space: nowrap; */
    }
    th,
    td {
        display: inline-block;
    }
    .logo {
        width: 200px;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: 13px;
        }
        td + td,
        th + th {
            width: auto;
            font-size: 13px;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
    }
    .schl-name {
        font-size: 20px;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        @page {
            size: A4 landscape;
            margin-top: none;
            padding-top: none;
            size: 25in 20in;
        }
        table,
        td,
        tr,
        th {
          /* text-align: center !important; */
          /* margin-top: none; */
          padding: 0.6rem !important;
          font-size: 28px !important;
          /* font-weight: bold !important; */
          /* border-bottom: 1px solid black; */
          border: 1px solid black;
        }
        .logo {
        width: 300px !important;
        }
        .schl-name {
            font-size: 40px !important;
        }
        .table-container {
            border: 1px solid black;
        }
    }
    .table-container {
        overflow-x: hidden;
        overflow: hidden;
        /* margin-left: 5rem !important; */
    }
</style>
